import { Box, Button, Grid, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

const MenuLastContainer = () => {
	const navigate = useNavigate();

	return (
		<Grid container display="flex" justifyContent="center" mb={2} alignItems="center">
			<Grid size={{ xs: 10, sm: 10, md: 8, lg: 8, xl: 6 }}>
				<Box
					className="stickbox"
					width="100%"
					display="flex"
					justifyContent="center"
					mb={2}
					alignItems="center"
					flexDirection={'column'}
				>
					<Typography variant="h6" align="center" gutterBottom className="mb-4">
						Exceptional food, tailored to your occasion. Request a custom quote and let
						us craft a catering experience that delights every guest.{' '}
					</Typography>
					<Button
						variant="contained"
						color="primary"
						sx={{ width: '80%' }}
						onClick={() => navigate('/customized-menu')}
					>
						Get Customized Quotation
					</Button>
				</Box>
			</Grid>
		</Grid>
	);
};

export default MenuLastContainer;
